export default __webpack_public_path__ + "static/media/file_excel_32.79e13ba5.svg";